import Image from 'next/image';
import { FC } from 'react';

import Description from './Description';
import Name from './Name';
import Wrapper, { WrapperProps } from './Wrapper';

export type BadgeProps = Pick<WrapperProps, 'borderColor'> & {
  logo: string;
  name: string;
  description: string;
};

const Badge: FC<BadgeProps> = ({ name, description, logo, borderColor }) => {
  return (
    <Wrapper borderColor={borderColor}>
      <Image
        alt={name}
        src={logo}
        width={70}
        height={70}
      />
      <div>
        <Name>{name}</Name>
        <Description>{description}</Description>
      </div>
    </Wrapper>
  );
};

export default Badge;
